import * as React from 'react'
import AppFeatureEditor from '../AppFeatureEditor'
import {Feature, FeatureStatus} from '../../../core/models'
import OverlayLoader from '../../../core/components/Loading/OverlayLoading'
import {Props} from '../../../core/components/FeatureViews/FeatureEditor'

class RegPlanEditor extends AppFeatureEditor {
  mountedSetOriginals = false
  protected loadDependencies(props: Props) {
    if (props.editsDispatcher) {
      const isDifferentFeature =
        props.feature.getId() != this.props.feature.getId() ||
        props.layerInfo.sourceDescription.id != this.props.layerInfo.sourceDescription.id
      if (!this.mountedSetOriginals || isDifferentFeature) {
        if (isDifferentFeature) {
          props.editsDispatcher.cancel({[this.props.layerInfo.url]: {[this.props.feature.getId()]: this.props.feature}})
        }
        this.mountedSetOriginals = true
        props.editsDispatcher.setOriginals({[props.layerInfo.url]: {[props.feature.getId()]: props.feature}}, () => {})
      }
      this.setState({
        ...this.state,
        feature: props.feature.clone(),
        loading: false
      })
    } else {
      // when there is not editsDispatcher and we receive props this means a new edit is coming, we have to default everything
      this.setState({
        ...this.state,
        loading: false,
        errorMessage: '',
        feature: props.feature.clone(),
        success: false,
        showGuiltyFields: false
      })
    }
  }

  getSaveControls(feature: Feature): JSX.Element {
    return (
      <div style={{display: 'flex'}}>
        <button
          type="button"
          disabled={this.isSaveDisabled(feature)}
          className={this.props.buttonsClassname || 'button margin width'}
          onClick={() => this.trySave(feature)}
        >
          Запис
        </button>
        <button
          type="button"
          className={this.props.buttonsClassname || 'button margin width'}
          onClick={() => this.props.onCancel!(feature)}
        >
          Отказ
        </button>
      </div>
    )
  }

  render() {
    const feature = this.props.editsDispatcher ? this.props.feature : this.state.feature
    if (this.state.success) {
      return (
        <div style={{padding: '10px', boxSizing: 'border-box'}}>
          <div className="success-div">Записът беше успешен</div>
          <button
            type="button"
            className={this.props.buttonsClassname || 'button width'}
            onClick={() => {
              this.setState({...this.state, success: false})
            }}
          >
            {feature.status == FeatureStatus.New ? 'Създай нов' : 'Редактирай отново'}
          </button>
        </div>
      )
    }
    return (
      <div style={{...this.props.style, position: 'relative', height: '400px', overflow: 'auto'}}>
        <div style={{margin: '10px'}}>
          <OverlayLoader size="60px" show={this.state.loading} />
          {this.renderEditingBody(feature, this.props.layerInfo)}
          {this.props.layerInfo.sourceDescription.hasAttachments ? this.getAttachmentsViewer(feature) : null}
          {this.state.showGuiltyFields && this.controlsHaveErrors(feature) ? (
            <div className="error-div">Моля, оправете грешките</div>
          ) : null}
          {this.state.errorMessage ? <div className="error-div">{this.state.errorMessage}</div> : null}
          {this.getSaveControls(feature)}
          <br></br>
        </div>
      </div>
    )
  }
}

export default RegPlanEditor
